import { Link } from 'react-router-dom';
const RequestConsultation = () => {

  return (
    <section className="request-const">
      <div className='container'>
        <div className='row'>
          <div className="trading-card">

            <div className="section-header mb-3">
              <h2 className="text-uppercase">Your edge in<span className="style2"> trading and investing</span> starts here</h2>
              <p className="sub-heading">Get institutional-grade, personalized service, engineered for professionals.</p>
            </div>

            <div className="action-buttons">
              <Link to="/contact" className="btn btn-primary">
                Request Consultation
                <span className="btn-arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestConsultation;